import { flow, get } from 'lodash/fp';

const getItemsNumber = get(['pagination', 'pageNumber']);
const getActivePage = flow(get(['pagination', 'currentPage']), Number);

export default {
  activePage: getActivePage,
  items: getItemsNumber,
};
